import React, { useState } from 'react';
import './login.css';

import Eye from '../../assets/icons/solar_eye-outline.svg'
 import Logo from '../../assets/icons/logo.svg'
import AuthService from '../../services/auth.service';
import { useNavigate } from 'react-router-dom';

// import ModalResetPassword from './../components/resetPassword';
// import AuthService from '../services/auth.service';
const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const handleToggle = () => {
    setShowPassword(!showPassword);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    AuthService.login(email, password).then(
      (Response) => {
       /// console.log('res', Response);
        // Navigating to '/users'
        window.location.href = '/dashboard';
      //navigate('/dashboard');
      },
      (error) => {
        if (error.response && error.response.status === 400) {
          console.log('password not valide', error.response.data.message);
          setError(error.response.data.message);
          return;
        }
        if (error.response && error.response.status === 404) {
          console.log('user not found');
          setError('user not found');
          return;
        }
        console.log('err', error);
        // Réactiver le bouton de connexion si l'erreur est due à un mot de passe incorrect
        if (error.response && error.response.status === 401) {
        // Réinitialiser l'erreur
        }
      }
    );
  };
  const updateIsOpen = () => { setIsOpen(!isOpen)} 
  
  return (
    <div className="container-fluid login min-vh-100">
    {/* {isOpen ? <ModalResetPassword isOpen={isOpen} updateIsOpen={updateIsOpen}/> :(null)} */}

    <div className=" row">
        <div className="col-md-4 d-flex align-items-start justify-content-center left">
            <img src={Logo} alt='logo' className='w-50 mt-5'/>

        </div>
        <div className="col-md-8 right"> 
        <div className="form-login ">
            <h1 className='title-login'>Se connecter</h1>
    <form onSubmit={handleSubmit}>
      <div>
        <label htmlFor="username" className='label-login'>E-mail</label></div><div>
        <input
        className="form-control"
          type="email"
          id="email"
          value={email}
          onChange={(event) => {setEmail(event.target.value);setError('');}}
          placeholder='Adresse e-mail'
        />
      </div>
      <div className="password-field mt-20">
      <label htmlFor="password">Mot de passe</label></div>
       <div  className="password-input-container">   
        <input
         className="form-control password"
          type={showPassword ? 'text' : 'password'}
          id="password"
          value={password}
          onChange={(event) => {setPassword(event.target.value);   setError('');}}
          placeholder='Mot de passe'
        />
         {showPassword ? (
          <img src={Eye} className="password-icon" alt ="password show" onClick={handleToggle} />
        ) : (
          <img src={Eye} className="password-icon" alt ="password-hide" onClick={handleToggle} />
        )}
       
      </div> 
      
      {/* <div className='float-right mt-24'>
        <a onClick={()=>{updateIsOpen()}} className='cta '>Mot de passe oublié</a>
      </div> */}
      <button type="submit" className='btn-primary-ko w-100 mt-20'>Se connecter</button>
      <span className='text-danger pt-5'>{error}</span>
    </form>
    </div></div>
       
    </div>
    </div>
  );
}

export default Login;
